const ApiUrl = process.env.NEXT_PUBLIC_API_URL;
// module.exports = url;

const UrlParamsReplace = (url, params = {}) => {
  let urlWithPrefix = `${ApiUrl}${url}`;
  if (params) {
    Object.keys(params).forEach(
      (key) => (urlWithPrefix = urlWithPrefix.replace(`:${key}`, params[key]))
    );
  }
  return urlWithPrefix;
};

export const GET_ALL_PUBLIC_COUPON_URL = UrlParamsReplace("/admin/coupons");
export const CREATE_OR_UPDATE_PUBLIC_COUPON_URL =
  UrlParamsReplace("/admin/coupons");
export const GET_COUPON_BY_SEARCHTEXT_URL = (searchText) =>
  UrlParamsReplace("/admin/coupons/:searchText", { searchText });

export const ADMIN_GOOGLE_LOGIN_URL = () =>
  UrlParamsReplace("/auth/google?state=admin");
export const DUMP_LOGS_TO_AWS_CLOUD_WATCH_URL =
  UrlParamsReplace("/dump-logs/aws");
export const VERIFY_TOKEN_URL = () => UrlParamsReplace("/auth/verify");
export const GET_ALL_MEMBER_FILTER_URL = UrlParamsReplace("/members/filter");
export const DELETE_MEMBER_URL = (id) =>
  UrlParamsReplace("/members/:id", { id });
export const CREATE_MEMBER_URL = () => UrlParamsReplace("/members");
export const EDIT_MEMBER_BY_ID_URL = (id) =>
  UrlParamsReplace("/members/:id", { id });
export const GET_MEMBER_BY_ID_URL = (id) =>
  UrlParamsReplace("/members/:id", { id });

export const GET_INFO_CARD_URL = (offset, limit, searchText) =>
  UrlParamsReplace(
    "/admin/info-card?offset=:offset&limit=:limit&searchText=:searchText",
    { offset, limit, searchText }
  );
export const CREATE_INFO_CARD_URL = () => UrlParamsReplace("/admin/info-card");
export const UPDATE_INFO_CARD_URL = (id) =>
  UrlParamsReplace("/admin/info-card/:id", { id });
export const GET_INFO_CARD_BY_ID_URL = (id) =>
  UrlParamsReplace("/admin/info-card/:id", { id });

export const GET_UPLOAD_PRE_SIGNED_URL = UrlParamsReplace(
  "/aws/get-upload-pre-signed-url"
);
export const GET_PRE_SIGNED_URL = (fileKey) =>
  UrlParamsReplace("/aws/get-pre-signed-url?fileKey=:fileKey", { fileKey });

export const GET_ALL_PRODUCT_INFO_CARD_FILTER_URL = (
  offset,
  limit,
  searchText
) =>
  UrlParamsReplace(
    "/admin/product-info-card?offset=:offset&limit=:limit&searchText=:searchText",
    { offset, limit, searchText }
  );
export const EDIT_PRODUCT_INFO_CARD_BY_ID_URL = (id) =>
  UrlParamsReplace("/admin/product-info-card/:id", { id });
export const GET_PRODUCTS_BY_SEARCHTEXT_URL = (searchText) =>
  UrlParamsReplace("/admin/products?searchText=:searchText", { searchText });
export const GET_SIMILAR_PRODUCT_OPTIONS = ({ productId, searchText }) =>
  UrlParamsReplace(
    "/admin/similar-product-options/:productId?searchText=:searchText",
    { productId, searchText }
  );
export const CREATE_PRODUCT_INFO_CARD_URL = () =>
  UrlParamsReplace("/admin/product-info-card");
export const EDIT_PRODUCT_INFO_CARD_URL = (id) =>
  UrlParamsReplace("/admin/product-info-card/:id", { id });
export const GET_ALL_SIMILAR_PRODUCT_FILTER_URL = UrlParamsReplace(
  "/similar-products/filter"
);
export const DELETE_SIMILAR_PRODUCT_URL = (id) =>
  UrlParamsReplace("/similar-products/:id", { id });
export const CREATE_SIMILAR_PRODUCT_URL = () =>
  UrlParamsReplace("/similar-products");
export const EDIT_SIMILAR_PRODUCT_BY_ID_URL = (id) =>
  UrlParamsReplace("/similar-products/:id", { id });
export const GET_SIMILAR_PRODUCT_BY_ID_URL = (id) =>
  UrlParamsReplace("/similar-products/:id", { id });

export const GET_ALL_SIZE_URL = (offset, limit) =>
  UrlParamsReplace("/sizefilters?offset=:offset&limit=:limit", {
    offset,
    limit,
  });
export const GET_ALL_ACTIVITY_URL = (offset, limit, gender = 'women') =>
  UrlParamsReplace("/activities?offset=:offset&limit=:limit&gender=:gender", {
    offset,
    limit,
    gender,
  });
export const CREATE_HOME_PAGE_ACTIVITY_URL = () =>
  UrlParamsReplace("/activities");
export const GET_ALL_ADMIN_ACTIVITY_URL = (offset, limit, gender = 'women') =>
  UrlParamsReplace("/admin/activities?offset=:offset&limit=:limit&gender=:gender", {
    offset,
    limit,
    gender,
  });
export const DELETE_ACTIVITY_URL = (id) =>
  UrlParamsReplace("/activities/:id", { id });
export const UPDATE_ACTIVITY_STATUS_URL = (id) =>
  UrlParamsReplace("/activities/:id/status", { id });
export const UPDATE_ACTIVITY_URL = (id) =>
  UrlParamsReplace("/activities/:id", { id });
export const UPDATE_ACTIVITY_LOGOURL = (id) =>
  UrlParamsReplace("/activities/:id/logoUrl", { id });
export const UPDATE_HOME_PAGE_ACTIVITY_ORDER_URL = () =>
  UrlParamsReplace("/activities/order");
export const GET_ALL_CATEGORY_URL = (offset, limit, gender = 'women') =>
  UrlParamsReplace("/categories?offset=:offset&limit=:limit&gender=:gender", {
    offset,
    limit,
    gender,
  });
export const CREATE_HOME_PAGE_CATEGORY_URL = () =>
  UrlParamsReplace("/categories");
export const GET_ALL_ADMIN_CATEGORY_URL = (offset, limit, gender = 'women') =>
  UrlParamsReplace("/admin/categories?offset=:offset&limit=:limit&gender=:gender", {
    offset,
    limit,
    gender,
  });
export const DELETE_CATEGORY_URL = (id) =>
  UrlParamsReplace("/categories/:id", { id });
export const UPDATE_CATEGORY_STATUS_URL = (id) =>
  UrlParamsReplace("/categories/:id/status", { id });
export const UPDATE_CATEGORY_URL = (id) =>
  UrlParamsReplace("/categories/:id", { id });
export const UPDATE_HOME_PAGE_CATEGORY_ORDER_URL = () =>
  UrlParamsReplace("/categories/order");
export const CREATE_HOME_PAGE_SIZE_URL = () => UrlParamsReplace("/sizefilters");
export const GET_ALL_ADMIN_SIZE_URL = (offset, limit) =>
  UrlParamsReplace("/admin/sizefilters?offset=:offset&limit=:limit", {
    offset,
    limit,
  });
export const DELETE_SIZE_URL = (id) =>
  UrlParamsReplace("/sizefilters/:id", { id });
export const UPDATE_SIZE_STATUS_URL = (id) =>
  UrlParamsReplace("/sizefilters/:id/status", { id });
export const UPDATE_SIZE_URL = (id) =>
  UrlParamsReplace("/sizefilters/:id", { id });
export const UPDATE_HOME_PAGE_SIZE_ORDER_URL = () =>
  UrlParamsReplace("/sizefilters/order");
export const CREATE_HOME_PAGE_SUBCATEGORY_URL = () =>
  UrlParamsReplace("/sub-categories");
export const GET_ALL_SUBCATEGORY_BY_CATEGORY_URL = (id) =>
  UrlParamsReplace("/admin/categories/:id/sub-categories", { id });
export const DELETE_SUBCATEGORY_URL = (id) =>
  UrlParamsReplace("/sub-categories/:id", { id });
export const UPDATE_SUBCATEGORY_STATUS_URL = (id) =>
  UrlParamsReplace("/sub-categories/:id/status", { id });
export const UPDATE_SUBCATEGORY_URL = (id) =>
  UrlParamsReplace("/sub-categories/:id", { id });
export const UPDATE_HOME_PAGE_SUBCATEGORY_ORDER_URL = () =>
  UrlParamsReplace("/sub-categories/order");
export const GET_COLLECTION_BY_SEARCH_TEXT_URL = (searchText) =>
  UrlParamsReplace("/collection?searchText=:searchText", { searchText });
export const CREATE_HOME_PAGE_BANNER_URL = () =>
  UrlParamsReplace("/admin/banners");
export const GET_BANNER_BY_ID_URL = (bannerId) =>
  UrlParamsReplace("/admin/banners/:bannerId", { bannerId });
export const UPDATE_HOME_PAGE_BANNER_URL = (bannerId) =>
  UrlParamsReplace("/admin/banners/:bannerId", { bannerId });
export const BULK_UPDATE_HOME_PAGE_BANNER_ORDER_URL = (bannerId) =>
  UrlParamsReplace("/admin/banner-display-order");
export const GET_ALL_HOME_PAGE_BANNER_URL = (
  offset,
  limit,
  isActive,
  bannerType,
  gender = 'women'
) =>
  UrlParamsReplace(
    "/admin/banners-by-filter?offset=:offset&limit=:limit&isActive=:isActive&type=:bannerType&gender=:gender",
    { offset, limit, isActive, bannerType, gender }
  );
export const GET_ALL_BANNER_URL = (offset, limit, isActive, bannerType, gender = 'women', isHeader = '') =>
  UrlParamsReplace(
    "/admin/banners?offset=:offset&limit=:limit&isActive=:isActive&type=:bannerType&gender=:gender&isHeader=:isHeader",
    { offset, limit, isActive, bannerType, gender, isHeader }
  );
export const DELETE_BANNER_URL = (bannerId) =>
  UrlParamsReplace("/admin/banners/:bannerId", { bannerId });

export const GET_ALL_CART_SIMILAR_PRODUCT_URL = (offset, limit, searchText) =>
  UrlParamsReplace(
    "/admin/cart-similar-product?offset=:offset&limit=:limit&searchText=:searchText",
    { offset, limit, searchText }
  );
export const CREATE__UPDATE_CART_SIMILAR_PRODUCT_URL = () =>
  UrlParamsReplace("/admin/cart-similar-product");

export const GET_ALL_PRODUCT_SECTION_FILTER_URL = (offset, limit, searchText) =>
  UrlParamsReplace(
    "/product-section?offset=:offset&limit=:limit&searchText=:searchText",
    { offset, limit, searchText }
  );
export const GET_PRODUCT_SECTION_BY_ID_URL = (id) =>
  UrlParamsReplace("/product-section/:id", { id });
export const CREATE_PRODUCT_SECTION_URL = () =>
  UrlParamsReplace("/product-section");
export const EDIT_PRODUCT_SECTION_URL = (id) =>
  UrlParamsReplace("/product-section/:id", { id });

export const GET_MARKET_LINE_TEXT_URL = UrlParamsReplace("/marketing-line");
export const CREATE_MARKET_LINE_TEXT_URL = UrlParamsReplace(
  "/admin/marketing-line"
);

export const CREATE_CONFIG_URL = UrlParamsReplace("/configs");

export const GET_ALL_PRODUCT_METAFIELDS_URL = UrlParamsReplace("/products/metafield");
export const GET_ALL_PRODUCT_METAFIELD_VALUES_URL = ({ collectionId }) => UrlParamsReplace("/products/metafieldValues?collectionId=:collectionId", { collectionId });

export const UPDATE_CATEGORY_FILTER_URL = (id) => UrlParamsReplace("/admin/categories/:id/filters", { id });
export const UPDATE_ACTIVITY_FILTER_URL = (id) => UrlParamsReplace("/admin/activities/:id/filters", { id });
export const GET_CONFIG_BY_KEY_URL = (key) =>
  UrlParamsReplace("/configs/:key", { key });

export const UPDATE_CONFIG_URL = (key) =>
  UrlParamsReplace("/configs/:key", { key });
export const CREATE_HOME_PAGE_PROMINENT_CATEGORY_URL = () =>
  UrlParamsReplace("/admin/prominent-categories");
export const GET_ALL_ADMIN_PROMINENT_CATEGORY_URL = (offset, limit) =>
  UrlParamsReplace("/admin/prominent-categories?offset=:offset&limit=:limit", {
    offset,
    limit,
  });
export const DELETE_PROMINENT_CATEGORY_URL = (id) =>
  UrlParamsReplace("/admin/prominent-categories/:id", { id });
export const UPDATE_PROMINENT_CATEGORY_STATUS_URL = (id) =>
  UrlParamsReplace("/admin/prominent-categories/:id/status", { id });
export const UPDATE_PROMINENT_CATEGORY_URL = (id) =>
  UrlParamsReplace("/admin/prominent-categories/:id", { id });
export const UPDATE_HOME_PAGE_PROMINENT_CATEGORY_ORDER_URL = () =>
  UrlParamsReplace("/admin/prominent-categories/order");
export const GET_GLOBAL_DISCOUNT_PERCENTAGE_URL = UrlParamsReplace("/admin/global-discount-percentage");
export const CREATE_OR_UPDATE_GLOBAL_DISCOUNT_PERCENTAGE_URL = UrlParamsReplace("/admin/global-discount-percentage");
export const GET_EDD_BUFFER_DAYS_URL = UrlParamsReplace("/admin/edd-buffer-days");
export const CREATE_OR_UPDATE_EDD_BUFFER_DAYS_URL = UrlParamsReplace("/admin/edd-buffer-days");
export const GET_EXPRESS_DELIVERY_FEES_URL = UrlParamsReplace("/admin/express-delivery-fees");
export const CREATE_OR_UPDATE_EXPRESS_DELIVERY_FEES_URL = UrlParamsReplace("/admin/express-delivery-fees");
export const GET_ALL_HOMEPAGE_SECTIONS_URL = (offset, limit, gender = 'women') =>
  UrlParamsReplace("/admin/homepage-sections?offset=:offset&limit=:limit&gender=:gender", { offset, limit, gender });
export const DELETE_HOMEPAGE_SECTION_URL = (id) =>
  UrlParamsReplace("/admin/homepage-sections/:id", { id });
export const UPDATE_SECTION_STATUS_BY_ID = (homepageSectionsId) =>
  UrlParamsReplace("/admin/homepage-sections/:homepageSectionsId/status", { homepageSectionsId });
export const GET_SECTION_BY_ID = (id) =>
  UrlParamsReplace("/admin/homepage-section/:id", { id });
export const UPDATE_SECTION_BY_ID = (id) =>
  UrlParamsReplace("/admin/homepage-sections/:id", { id });
export const CREATE_SECTION_BY_ID = () =>
  UrlParamsReplace("/admin/homepage-sections");

export const GET_ANNOUNCEMENT_BAR_URL = (gender = 'women') => UrlParamsReplace("/admin/announcement-bar?gender=:gender", { gender });
export const CREATE_OR_UPDATE_ANNOUNCEMENT_BAR_URL = UrlParamsReplace("/admin/announcement-bar");

export const CREATE_HOMEPAGE_WIDGET_URL = UrlParamsReplace("/admin/homepage-widget");
export const GET_HOMEPAGE_WIDGET_URL = (id) => UrlParamsReplace("/admin/homepage-widget/:id", { id });
export const GET_HOMEPAGE_WIDGET_USING_DISPLAY_ORDER_URL = (displayOrder, gender = 'women') => UrlParamsReplace("/admin/homepage-widget?displayOrder=:displayOrder&gender=:gender", { displayOrder, gender });
export const UPDATE_HOMEPAGE_WIDGET_URL = (id) => UrlParamsReplace("/admin/homepage-widget/:id", { id });

export const CREATE_HOMEPAGE_WIDGET_BANNER_URL = UrlParamsReplace("/admin/homepage-widget-banner");
export const DELETE_HOMEPAGE_WIDGET_BANNER_URL = (homepageWidgetBannerId) => UrlParamsReplace("/admin/homepage-widget-banner/:homepageWidgetBannerId", { homepageWidgetBannerId });
export const GET_ALL_HOMEPAGE_WIDGET_BANNER_URL = (homepageWidgetId, limit, offset, isActive, type, gender = 'women') =>
  UrlParamsReplace("/admin/homepage-widget-banner?homepageWidgetId=:homepageWidgetId&offset=:offset&limit=:limit&isActive=:isActive&type=:type&gender=:gender", { homepageWidgetId, limit, offset, isActive, type, gender });
export const UPDATE_HOMEPAGE_WIDGET_BANNER_DISPLAY_ORDER_URL = UrlParamsReplace("/admin/homepage-widget-banner-display-order");
export const UPDATE_HOMEPAGE_WIDGET_BANNER_STATUS_URL = (homepageWidgetBannerId) => UrlParamsReplace("/admin/homepage-widget-banner/:homepageWidgetBannerId", { homepageWidgetBannerId });
export const CREATE_OR_UPDATE_SHOW_PERCENTAGE_OFF_URL = UrlParamsReplace("/admin/show-percentage-off");
export const GET_SHOW_PERCENTAGE_OFF_URL = UrlParamsReplace("/admin/show-percentage-off");

export const CLEAR_CACHE_URL = () => UrlParamsReplace("/admin/cache/clear");

export const GET_ALL_PICTURE_IN_PICTURE_URL = (offset, limit, isActive) =>
  UrlParamsReplace(
    "/admin/pip?offset=:offset&limit=:limit&isActive=:isActive",
    { offset, limit, isActive }
  );
export const CREATE_PICTURE_IN_PICTURE_URL = () =>
  UrlParamsReplace("/admin/pip");
export const GET_PICTURE_IN_PICTURE_BY_ID_URL = (pipId) =>
  UrlParamsReplace("/admin/pip/:pipId", { pipId });
export const UPDATE_PICTURE_IN_PICTURE_URL = (pipId) =>
  UrlParamsReplace("/admin/pip/:pipId", { pipId });
export const DELETE_PICTURE_IN_PICTURE_URL = (pipId) =>
  UrlParamsReplace("/admin/pip/:pipId", { pipId });
export const UPDATE_PICTURE_IN_PICTURE_STATUS_URL = (pipId) =>
  UrlParamsReplace("/admin/pip/:pipId/status", { pipId });

export const GET_ALL_ZENIM_WEAR_HERO_VIDEOS_URL = (offset, limit, isActive, gender = 'women') =>
  UrlParamsReplace(
    "/admin/zenim-wear/hero-videos?offset=:offset&limit=:limit&isActive=:isActive&gender=:gender",
    { offset, limit, isActive, gender }
  );
export const CREATE_ZENIM_WEAR_HERO_VIDEO_URL = () =>
  UrlParamsReplace("/admin/zenim-wear/hero-videos");
export const GET_ZENIM_WEAR_HERO_VIDEO_BY_ID_URL = (videoId) =>
  UrlParamsReplace("/admin/zenim-wear/hero-videos/:videoId", { videoId });
export const UPDATE_ZENIM_WEAR_HERO_VIDEO_URL = (videoId) =>
  UrlParamsReplace("/admin/zenim-wear/hero-videos/:videoId", { videoId });
export const DELETE_ZENIM_WEAR_HERO_VIDEO_URL = (videoId) =>
  UrlParamsReplace("/admin/zenim-wear/hero-videos/:videoId", { videoId });
export const UPDATE_ZENIM_WEAR_HERO_VIDEO_STATUS_URL = (videoId) =>
  UrlParamsReplace("/admin/zenim-wear/hero-videos/:videoId/status", { videoId });

export const GET_ALL_ZENIM_WEAR_SECONDARY_VIDEOS_URL = (offset, limit, isActive, gender = 'women') =>
  UrlParamsReplace(
    "/admin/zenim-wear/secondary-videos?offset=:offset&limit=:limit&isActive=:isActive&gender=:gender",
    { offset, limit, isActive, gender }
  );
export const CREATE_ZENIM_WEAR_SECONDARY_VIDEO_URL = () =>
  UrlParamsReplace("/admin/zenim-wear/secondary-videos");
export const GET_ZENIM_WEAR_SECONDARY_VIDEO_BY_ID_URL = (videoId) =>
  UrlParamsReplace("/admin/zenim-wear/secondary-videos/:videoId", { videoId });
export const UPDATE_ZENIM_WEAR_SECONDARY_VIDEO_URL = (videoId) =>
  UrlParamsReplace("/admin/zenim-wear/secondary-videos/:videoId", { videoId });
export const DELETE_ZENIM_WEAR_SECONDARY_VIDEO_URL = (videoId) =>
  UrlParamsReplace("/admin/zenim-wear/secondary-videos/:videoId", { videoId });
export const UPDATE_ZENIM_WEAR_SECONDARY_VIDEO_STATUS_URL = (videoId) =>
  UrlParamsReplace("/admin/zenim-wear/secondary-videos/:videoId/status", { videoId });

export const GET_ALL_ZENIM_WEAR_STORY_GRID_URL = (offset, limit, isActive, gender = 'women') =>
  UrlParamsReplace(
    "/admin/zenim-wear/story-grid?offset=:offset&limit=:limit&isActive=:isActive&gender=:gender",
    { offset, limit, isActive, gender }
  );
export const CREATE_ZENIM_WEAR_STORY_GRID_URL = () =>
  UrlParamsReplace("/admin/zenim-wear/story-grid");
export const GET_ZENIM_WEAR_STORY_GRID_BY_ID_URL = (videoId) =>
  UrlParamsReplace("/admin/zenim-wear/story-grid/:videoId", { videoId });
export const UPDATE_ZENIM_WEAR_STORY_GRID_URL = (videoId) =>
  UrlParamsReplace("/admin/zenim-wear/story-grid/:videoId", { videoId });
export const DELETE_ZENIM_WEAR_STORY_GRID_URL = (videoId) =>
  UrlParamsReplace("/admin/zenim-wear/story-grid/:videoId", { videoId });
export const UPDATE_ZENIM_WEAR_STORY_GRID_STATUS_URL = (videoId) =>
  UrlParamsReplace("/admin/zenim-wear/story-grid/:videoId/status", { videoId });

export const GET_ZENIM_WEAR_STYLE_INSPIRATION_SETTINGS_URL = (gender = 'women') =>
  UrlParamsReplace(
    "/admin/zenim-wear/style-inspiration/settings?gender=:gender",
    { gender }
  );
export const UPDATE_ZENIM_WEAR_STYLE_INSPIRATION_SETTINGS_URL = () =>
  UrlParamsReplace("/admin/zenim-wear/style-inspiration/settings");

export const GET_ALL_ZENIM_WEAR_STYLE_INSPIRATION_VIDEOS_URL = (offset, limit, isActive, gender = 'women') =>
  UrlParamsReplace(
    "/admin/zenim-wear/style-inspiration/videos?offset=:offset&limit=:limit&isActive=:isActive&gender=:gender",
    { offset, limit, isActive, gender }
  );
export const CREATE_ZENIM_WEAR_STYLE_INSPIRATION_VIDEO_URL = () =>
  UrlParamsReplace("/admin/zenim-wear/style-inspiration/videos");
export const GET_ZENIM_WEAR_STYLE_INSPIRATION_VIDEO_BY_ID_URL = (videoId) =>
  UrlParamsReplace("/admin/zenim-wear/style-inspiration/videos/:videoId", { videoId });
export const UPDATE_ZENIM_WEAR_STYLE_INSPIRATION_VIDEO_URL = (videoId) =>
  UrlParamsReplace("/admin/zenim-wear/style-inspiration/videos/:videoId", { videoId });
export const DELETE_ZENIM_WEAR_STYLE_INSPIRATION_VIDEO_URL = (videoId) =>
  UrlParamsReplace("/admin/zenim-wear/style-inspiration/videos/:videoId", { videoId });
export const UPDATE_ZENIM_WEAR_STYLE_INSPIRATION_VIDEO_STATUS_URL = (videoId) =>
  UrlParamsReplace("/admin/zenim-wear/style-inspiration/videos/:videoId/status", { videoId });

export const GET_ALL_BLISSTERRY_HERO_VIDEOS_URL = (offset, limit, isActive, gender = 'women') =>
  UrlParamsReplace(
    "/admin/blissterry/hero-videos?offset=:offset&limit=:limit&isActive=:isActive&gender=:gender",
    { offset, limit, isActive, gender }
  );
export const CREATE_BLISSTERRY_HERO_VIDEO_URL = () =>
  UrlParamsReplace("/admin/blissterry/hero-videos");
export const GET_BLISSTERRY_HERO_VIDEO_BY_ID_URL = (videoId) =>
  UrlParamsReplace("/admin/blissterry/hero-videos/:videoId", { videoId });
export const UPDATE_BLISSTERRY_HERO_VIDEO_URL = (videoId) =>
  UrlParamsReplace("/admin/blissterry/hero-videos/:videoId", { videoId });
export const DELETE_BLISSTERRY_HERO_VIDEO_URL = (videoId) =>
  UrlParamsReplace("/admin/blissterry/hero-videos/:videoId", { videoId });
export const UPDATE_BLISSTERRY_HERO_VIDEO_STATUS_URL = (videoId) =>
  UrlParamsReplace("/admin/blissterry/hero-videos/:videoId/status", { videoId });

export const GET_ALL_BLISSTERRY_SPOTLIGHT_URL = (offset, limit, isActive, gender = 'women') =>
  UrlParamsReplace(
    "/admin/blissterry/spotlight?offset=:offset&limit=:limit&isActive=:isActive&gender=:gender",
    { offset, limit, isActive, gender }
  );
export const CREATE_BLISSTERRY_SPOTLIGHT_URL = () =>
  UrlParamsReplace("/admin/blissterry/spotlight");
export const GET_BLISSTERRY_SPOTLIGHT_BY_ID_URL = (videoId) =>
  UrlParamsReplace("/admin/blissterry/spotlight/:videoId", { videoId });
export const UPDATE_BLISSTERRY_SPOTLIGHT_URL = (videoId) =>
  UrlParamsReplace("/admin/blissterry/spotlight/:videoId", { videoId });
export const DELETE_BLISSTERRY_SPOTLIGHT_URL = (videoId) =>
  UrlParamsReplace("/admin/blissterry/spotlight/:videoId", { videoId });
export const UPDATE_BLISSTERRY_SPOTLIGHT_STATUS_URL = (videoId) =>
  UrlParamsReplace("/admin/blissterry/spotlight/:videoId/status", { videoId });

export const GET_BLISSTERRY_STYLE_INSPIRATION_SETTINGS_URL = (gender = 'women') =>
  UrlParamsReplace(
    "/admin/blissterry/style-inspiration/settings?gender=:gender",
    { gender }
  );
export const UPDATE_BLISSTERRY_STYLE_INSPIRATION_SETTINGS_URL = () =>
  UrlParamsReplace("/admin/blissterry/style-inspiration/settings");

export const GET_ALL_BLISSTERRY_STYLE_INSPIRATION_VIDEOS_URL = (offset, limit, isActive, gender = 'women') =>
  UrlParamsReplace(
    "/admin/blissterry/style-inspiration/videos?offset=:offset&limit=:limit&isActive=:isActive&gender=:gender",
    { offset, limit, isActive, gender }
  );
export const CREATE_BLISSTERRY_STYLE_INSPIRATION_VIDEO_URL = () =>
  UrlParamsReplace("/admin/blissterry/style-inspiration/videos");
export const GET_BLISSTERRY_STYLE_INSPIRATION_VIDEO_BY_ID_URL = (videoId) =>
  UrlParamsReplace("/admin/blissterry/style-inspiration/videos/:videoId", { videoId });
export const UPDATE_BLISSTERRY_STYLE_INSPIRATION_VIDEO_URL = (videoId) =>
  UrlParamsReplace("/admin/blissterry/style-inspiration/videos/:videoId", { videoId });
export const DELETE_BLISSTERRY_STYLE_INSPIRATION_VIDEO_URL = (videoId) =>
  UrlParamsReplace("/admin/blissterry/style-inspiration/videos/:videoId", { videoId });
export const UPDATE_BLISSTERRY_STYLE_INSPIRATION_VIDEO_STATUS_URL = (videoId) =>
  UrlParamsReplace("/admin/blissterry/style-inspiration/videos/:videoId/status", { videoId });

export const GET_APP_VERSION_CONFIG_URL = UrlParamsReplace("/admin/app-version");
export const CREATE_OR_UPDATE_APP_VERSION_CONFIG_URL = UrlParamsReplace("/admin/app-version");

export const GET_GOKWIK_TOGGLE_URL = UrlParamsReplace("/admin/gokwik-toggle");
export const SET_GOKWIK_TOGGLE_URL = UrlParamsReplace("/admin/gokwik-toggle");

export const GET_ORDER_SUCCESS_BANNER_URL = UrlParamsReplace("/admin/order-success-banner");
export const CREATE_OR_UPDATE_ORDER_SUCCESS_BANNER_URL = UrlParamsReplace("/admin/order-success-banner");
